import { TTERequirement } from '../types/contracts';

export const hasEligibilityWaitPeriod = (requirement: TTERequirement | ''): boolean => {
	return requirement === TTERequirement.afterWaitingPeriod ||
		requirement === TTERequirement.firstOfMonthAfterWaitingPeriod;
};
